import React from 'react';
import { Route, Routes } from 'react-router-dom';


// Constants
import { configs } from '../constants/configs/configs';

// components
import AccessCodeContainer from '../components/accessCode/AccessCodeContainer';
import EDESearchAndSelfDesignationContainer from '../components/broker/edeSearchAndDesignation/EDESearchAndSelfDesignationContainer';
import IdProofingContainer from '../components/broker/edeSearchAndDesignation/idProofing/IdProofingContainer';
import EDESearchContainer from '../components/broker/edeSearchAndDesignation/search/EDESearchContainer';
import HomeContainer from '../components/anonymous/home/HomeContainer';
import ArchiveHouseholdContainer from '../modules/archive-household';

// Modules

import { GeorgiaAccessDashboardContainer } from '../modules/georgia-access';
import { GAEPInsCompany, GAEPWebBroker } from '../modules/georgia-access/gaep';
import { AgentListing } from '../modules/georgia-access/agent-listing';
import AgentDetails from '../modules/georgia-access/agent-listing/agent-details';
import SecurityQuestionContainer from '@modules/referral/dynamicSecurityQuestions';

function GARoutes() {
    const {
        routes: {
            ACCESS_CODE,
            ANON_GA_AGENTS,
            ANON_GA_CARRIERS,
            ANON_GA_GAEPS,
            ARCHIVE_HOUSEHOLD,
            EDE_ID_PROOFING,
            EDE_SEARCH_PAGE,
            DYNAMIC_SECURITY_QUESTIONS,
            HOME,
            INDPORTAL
        }
    } = configs;

    return (
        <Routes>
            <Route path={ACCESS_CODE} element={<AccessCodeContainer />} />
            <Route path={ARCHIVE_HOUSEHOLD} element={<ArchiveHouseholdContainer />} />
            <Route path={EDE_ID_PROOFING} element={<EDESearchAndSelfDesignationContainer />}>
                <Route path={EDE_ID_PROOFING} element={<IdProofingContainer />} />
                <Route path={EDE_SEARCH_PAGE} element={<EDESearchContainer />} />
            </Route>
            <Route path={HOME} element={<HomeContainer />} />
            <Route path={ANON_GA_AGENTS} element={<AgentListing />} />
            <Route path={`${ANON_GA_AGENTS}/:agentId`} element={<AgentDetails />} />
            <Route path={ANON_GA_CARRIERS} element={<GAEPInsCompany />} />
            <Route path={ANON_GA_GAEPS} element={<GAEPWebBroker />} />
            <Route path={INDPORTAL} element={<GeorgiaAccessDashboardContainer />} />
            <Route path={DYNAMIC_SECURITY_QUESTIONS} element={<SecurityQuestionContainer />}  />
        </Routes>
    );
}

export { GARoutes };
